import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"


function RingsPage({categoryType}) {
  return (
    <CollectionMainPage categoryType={categoryType}/>
  )
}

export default RingsPage 